import store from '@state/store'

export default (routeTo, routeFrom, next) => {
  /*
     if the guest has not yet added room to the cart
     redirect to property landing page
  */
  const { params, query } = routeTo

  if (store.getters['cart/rooms/isEmpty']) {
    next({ name: 'property-landing', params, query })
  } else {
    store
      .dispatch('extras/fetch', { property: params.permalink })
      .then(() => next())
      .catch(() => next()) // 500 - internal server error
  }
}
